import { render, staticRenderFns } from "./DispensingTransfers.vue?vue&type=template&id=c26915d8"
import script from "./DispensingTransfers.vue?vue&type=script&lang=js"
export * from "./DispensingTransfers.vue?vue&type=script&lang=js"
import style0 from "./DispensingTransfers.vue?vue&type=style&index=0&id=c26915d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports